/*
  ATHLO+ — dashboard offline shell  →  window.HubPWA
  ===========================================================================
  "Opens instantly even on trails with terrible signal." Two layers:

  1) APP-SHELL SNAPSHOT (works today, theme-only): the Locker's key numbers
     (level, points, completion, titles) are cached in localStorage and painted
     INSTANTLY on next load — before HubProfile re-evaluates, and even fully
     offline — so the dashboard never shows a blank/spinner on a bad connection.

  2) SERVICE WORKER (best-effort): we attempt to register a SW for true offline
     page caching. NOTE: Shopify serves theme assets cross-origin (cdn.shopify),
     and a SW can only control its own origin/scope — so on a stock Shopify theme
     the SW registers with limited scope or is skipped. Full page-shell caching
     needs the SW served from the store root, which requires a Shopify app. This
     is a documented platform limit; layer (1) delivers the instant-open UX now.
*/
(function () {
  'use strict';
  var KEY = 'hub:shell';
  function save(snap) { try { localStorage.setItem(KEY, JSON.stringify(snap)); } catch (e) {} }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }

  // Paint a cached snapshot into the dashboard immediately (pre-hydration).
  function hydrate() {
    var snap = load(); if (!snap) return;
    var lb = document.getElementById('lk-levelbar'), ln = document.getElementById('lk-level-name');
    if (lb && ln && snap.level) {
      lb.hidden = false; ln.textContent = 'Hub Level · ' + snap.level;
      var nx = document.getElementById('lk-level-next'); if (nx && snap.next) nx.textContent = snap.next;
      var lf = document.getElementById('lk-level-fill'); if (lf && snap.progress != null) lf.style.width = Math.round(snap.progress * 100) + '%';
    }
    var cw = document.getElementById('lk-complete'), cl = document.getElementById('lk-complete-lbl');
    if (cw && cl && snap.completion != null) {
      cw.hidden = false; cl.textContent = 'Profile ' + snap.completion + '% complete';
      var cf = document.getElementById('lk-complete-fill'); if (cf) cf.style.width = snap.completion + '%';
    }
    document.documentElement.setAttribute('data-hub-cached', '1');
  }
  // Called by the Locker after a real evaluate() so next load is instant.
  function snapshot(state) {
    if (!state) return;
    save({ level: state.level, next: state.next ? (state.next.need + ' pts to ' + state.next.name) : 'Maxed out 🏆', progress: state.progress, completion: state.completion && state.completion.pct, titles: state.titles && state.titles.length, at: Date.now() });
  }

  function registerSW() {
    if (!('serviceWorker' in navigator)) return;
    try {
      var url = (window.HUB_SW_URL || '').trim(); if (!url) return; // set only if served same-origin
      navigator.serviceWorker.register(url).catch(function () {/* cross-origin/scope limit — expected on stock Shopify */});
    } catch (e) {}
  }

  window.HubPWA = { hydrate: hydrate, snapshot: snapshot };
  if (document.getElementById('lk-dash')) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate); else hydrate(); }
  registerSW();
})();
